export default __webpack_public_path__ + "static/media/php.6a2ad28b.png";